import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const ListingWrap = (props) => {
	const { title, empty, notice, children, SortChipsRP } = props;

	return (
		<Stack spacing={2}>
			<Stack
				flexWrap="wrap"
				direction="row"
				sx={{ px: 1 }}
				justifyContent="space-between"
			>
				{title && (
					<Typography mr={2} variant="h4">
						{title}
					</Typography>
				)}
				{SortChipsRP && <SortChipsRP />}
			</Stack>
			{notice}
			{!empty && <Box>{children}</Box>}
			{empty && (
				<Paper
					variant="outlined"
					sx={{
						background: 'transparent',
						p: 2,
						borderStyle: 'dashed',
						borderColor: 'text.secondary',
						color: 'text.secondary',
					}}
				>
					{empty}
				</Paper>
			)}
		</Stack>
	);
};

ListingWrap.propTypes = {
	title: PropTypes.string,
	empty: PropTypes.node,
	notice: PropTypes.node,
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]),
	SortChipsRP: PropTypes.elementType,
};

export default ListingWrap;
